import * as actionTypes from './actions';

const initialState = {
  authenticated: false,
  access_token: null,
  refresh_token: null,
  name: null,
  notifications: [],
  carriers: [],
  managers: [],
  cars: [],
  drivers: [],
  routes: null,
  requests: [],
  origin: null,
  destination: null,
  dragInitialData: { id: null, origin: null, destination: null },
  dragOverObj: null,
  showNewTrip: false,
  showNewRequest: false,
  showNewRequestLink: false,
  showNewCarrier: null,
  action: null,
  destination: null,
  locations: {},
  selectedTrip: null,
  tripCarrierHistory: null,
  sideBySideMode: false,
  tripleMode: false,
  managerId: null,
  managerName: null,
  users: [],
  showDriverForm: false,
  role: "GUEST",
  externalNotifications: {},
  codeToMessage: {
    400: "Неправильний запит.",
    401: "Ви повинні бути авторизовані.",
    404: "Запитуваний ресурс не існує.",
    403: "У вас недостатньо прав, щоб скористатися цим ресурсом.",
    500: "Невизначена помилка на сервері."
  },
  filterManager: false,
  filterDispatcher: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGIN:
      return {
        ...state,
        authenticated: true,
        access_token: action.access_token,
        refresh_token: action.refresh_token,
        name: action.name
      };
    case actionTypes.LOGOUT:
      return {
        ...state,
        access_token: null,
        refresh_token: null,
        authenticated: false,
        managerId: null,
        managerName: null
      };
    case actionTypes.FILTER_MANAGER:
      return {
        ...state,
        filterManager: action.filterManager
      };
    case actionTypes.MANAGER_NAME:
      return {
        ...state,
        managerName: action.managerName
      };
    case actionTypes.MANAGER_ID:
      return {
        ...state,
        managerId: action.managerId
      };
    case actionTypes.FILTER_DISPATCHER:
      return {
        ...state,
        filterDispatcher: action.filterDispatcher
      };
    case actionTypes.ADD_NOTIFICATION:
      const updatedNotifications = [...state.notifications];
      updatedNotifications.push({
        notification: action.notification,
        notificationType: action.notificationType,
        key: Math.floor(Math.random() * 1000000)
      });
      return {
        ...state,
        notifications: updatedNotifications
      };
    case actionTypes.SHOW_DRIVER_FORM:
      return {
        ...state,
        showDriverForm: action.showDriverForm,
        driver: action.driver
      };
    case actionTypes.REMOVE_NOTIFICATION:
      const deleteNotification = [...state.notifications].map(notification => ({ ...notification }));
      deleteNotification.splice(action.index, 1);
      return {
        ...state,
        notifications: [...deleteNotification]
      };
    case actionTypes.RESET_NOTIFICATION:
      return {
        ...state,
        notifications: []
      };
    case actionTypes.SELECT_TRIP:
      return {
        ...state,
        selectedTrip: action.selectedTrip
      };
    case actionTypes.SELECT_REQUEST:
      return {
        ...state,
        selectedRequest: action.selectedRequest
      };
    case actionTypes.SET_TRIP_CARRIER_HISTORY:
      return {
        ...state,
        tripCarrierHistory: action.tripCarrierHistory
      };
    case actionTypes.SET_CARRIERS:
      return {
        ...state,
        carriers: [...action.carriers]
      };
    case actionTypes.SET_MANAGERS:
      return {
        ...state,
        managers: [...action.managers]
      };
    case actionTypes.SET_CARS:
      return {
        ...state,
        cars: [...action.cars]
      };
    case actionTypes.SET_DRIVERS:
      return {
        ...state,
        drivers: [...action.drivers]
      };
    case actionTypes.ROUTES:
      let updatedRoutes = [...action.routes];
      for (let i = 0; i < updatedRoutes.length; i++) {
        let routeRequests = [];
        for (let j = 0; j < state.requests.length; j++) {
          if (parseInt(state.requests[j].tripId, 10) === parseInt(updatedRoutes[i].id, 10)) {
            routeRequests.push(state.requests[j]);
          }
        }
        updatedRoutes[i].requests = routeRequests;
      }
      return {
        ...state,
        selfRoutesChanged: true,
        routes: updatedRoutes
      };
    case actionTypes.REQUESTS:
      updatedRoutes = [...state.routes];
      for (let i = 0; i < updatedRoutes.length; i++) {
        let routeRequests = [];
        for (let j = 0; j < action.requests.length; j++) {
          if (parseInt(action.requests[j].tripId, 10) === parseInt(updatedRoutes[i].id, 10)) {
            routeRequests.push(action.requests[j]);
          }
        }
        updatedRoutes[i].requests = routeRequests;
      }
      return {
        ...state,
        selfRoutesChanged: true,
        routes: updatedRoutes,
        requests: action.requests
      };
    case actionTypes.ROUTES_UPDATED:
      return {
        ...state,
        selfRoutesChanged: false
      };
    case actionTypes.START_DRAG:
      return {
        ...state,
        dragInitialData: { id: action.id, origin: action.origin, destination: action.destination }
      };
    case actionTypes.DRAG_OVER_OBJ:
      return {
        ...state,
        dragOverObj: action.dragOverObj
      };
    case actionTypes.SHOW_NEW_TRIP:
      return {
        ...state,
        showNewTrip: action.showNewTrip,
        origin: action.origin,
        destination: action.destination
      };
    case actionTypes.SHOW_NEW_REQUEST_LINK:
      return {
        ...state,
        showNewRequestLink: action.showNewRequestLink
      };
    case actionTypes.SHOW_NEW_REQUEST:
      return {
        ...state,
        showNewRequest: action.showNewRequest,
        origin: action.origin,
        destination: action.destination
      };
    case actionTypes.SHOW_NEW_CARRIER:
      return {
        ...state,
        showNewCarrier: action.showNewCarrier
      };
    case actionTypes.SET_LOCATIONS:
      return {
        ...state,
        locations: action.locations
      };
    case actionTypes.SET_SIDE_BY_SIDE:
      return {
        ...state,
        sideBySideMode: action.sideBySide
      };
    case actionTypes.SET_TRIPLE_MODE:
      return {
        ...state,
        tripleMode: action.tripleMode
      };
    case actionTypes.SET_USERS:
      return {
        ...state,
        users: action.users
      };
    case actionTypes.SET_ROLE:
      return {
        ...state,
        role: action.role
      };
    case actionTypes.SET_EXTERNAL_NOTIFICATIONS:
      return {
        ...state,
        externalNotifications: action.externalNotifications
      };
    default:
      return state;
  }
  return state;
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducer.js